import {useEEToolAdapterContext} from "../contexts/eeToolAdapterContext";
import {KeyboardEvent, KeyboardEventHandler, useEffect, useRef} from "react";

export function AngleControl() {
    const context = useEEToolAdapterContext()
    const selectRef = useRef<HTMLSelectElement>(null);

    useEffect(() => {
        if (context.isAngleVisible) {
            if (selectRef.current) {
                selectRef.current.focus();
            }
        }
    }, [context.isAngleVisible]);

    if (!context.isAngleVisible)
        return <></>;

    return (
        <select style={{
            position: 'absolute',
            left: context.angleLeft,
            top: context.angleTop,
            zIndex: 100
        }}
                ref={selectRef}
                value={context.angleValue}
                onChange={(e) => context.handleAngle(e.target.value)}
        >
            <option value="90">Angle 90&deg;</option>
            <option value="112.5">Angle 112.5&deg;</option>
            <option value="135">Angle 135&deg;</option>
        </select>
    );
}
